import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchNowPlayingIfNeeded } from '../actions/NowPlayingActions';
import NowPlaying from '../components/NowPlayingComponent';


const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;
    const music = aovivoBar.MediaPlayer.isLive === 'otherMedia'
        ? aovivoBar.NowPlaying.music
        : aovivoBar.NowPlaying.musicLive;

    return {
        album: music.album,
        artist: music.artist,
        artistSlug: music.artistSlug,
        year: music.year,
        locked: aovivoBar.AovivoBar.locked,
        song: music.song,
        musicSlug: music.musicSlug,
        cover: music.cover,
    };
};
const mapDispatchToProps = (dispatch) => ({
    fetchNowPlayingIfNeeded: () => {
        dispatch(fetchNowPlayingIfNeeded());
    },
});
const NowPlayingContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(NowPlaying);


export default withRouter(NowPlayingContainer);
